import { createFileRoute, notFound } from "@tanstack/react-router";

import { JsonLd } from "@/components/layout/JsonLd";
import { FaqView } from "@/components/pages/FaqView";
import { faq } from "@/content/legal";
import { meta } from "@/content/meta";
import { isLocale } from "@/i18n/locales";
import { seoHead } from "@/lib/site";

export const Route = createFileRoute("/$locale/faq")({
  head: ({ params }) =>
    isLocale(params.locale)
      ? seoHead({
          locale: params.locale,
          path: "/faq",
          ...meta[params.locale].faq,
        })
      : {},
  component: FaqRoute,
});

function FaqRoute() {
  const { locale } = Route.useParams();
  if (!isLocale(locale)) throw notFound();
  const copy = faq[locale];

  return (
    <>
      <JsonLd
        data={{
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: copy.groups.flatMap((group) =>
            group.items.map((item) => ({
              "@type": "Question",
              name: item.q,
              acceptedAnswer: { "@type": "Answer", text: item.a },
            })),
          ),
        }}
      />
      <FaqView locale={locale} />
    </>
  );
}
